export default "__VITE_ASSET__BtXYlmXK__"